<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/AzureBillingPeriods">Azure Billing Periods</b-breadcrumb-item>
            <b-breadcrumb-item>{{billingPeriodId}}</b-breadcrumb-item>
            <b-breadcrumb-item :to="{name:'AzureBillingPeriodSubscriptions',params:{billingPeriodId:billingPeriodId}}">Subscriptions</b-breadcrumb-item>
            <b-breadcrumb-item active>{{subscriptionId}}</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="bg-dark card-header text-white">Edit Azure Billing Subscription</div>
            <div class="card-body">
                <div class="card">
                    <div class="card-header">
                        <ul class="card-header-tabs nav nav-tabs">
                            <li class="nav-item">
                                <a @click="currentTabComponent='TheAzureBillingSubscriptionForm'" class="active nav-link"
                                   data-toggle="tab"
                                   href="#">Subscription</a>
                            </li>
                            <li class="nav-item">
                                <a @click="currentTabComponent='TheAzureBillingChargesList'" class="nav-link"
                                   data-toggle="tab"
                                   href="#">Charges</a>
                            </li>
                            <li class="nav-item">
                                <a @click="currentTabComponent='TheAzureBillingAdjustmentList'" class="nav-link" data-toggle="tab"
                                   href="#">Adjustments</a>
                            </li>
                        </ul>
                    </div>
        <div id="tab-container">
            <keep-alive>
                <component :billing-period-id="billingPeriodId" :subscription-id="subscriptionId" v-bind:is="currentTabComponent"/>
            </keep-alive>
        </div>
            </div>
        </div></div>
    </div>
</template>

<script>
    import TheAzureBillingSubscriptionForm from "@/components/azureBilling/TheAzureBillingSubscriptionForm";
    import TheAzureBillingChargesList from "@/components/azureBilling/TheAzureBillingChargesList";
    import TheAzureBillingAdjustmentList from "@/components/azureBilling/TheAzureBillingAdjustmentList";
    export default {
        name: "TheAzureBillingSubscriptionDetails",
        components: {TheAzureBillingAdjustmentList, TheAzureBillingChargesList, TheAzureBillingSubscriptionForm},
        data() {
            return {
                currentTabComponent: 'TheAzureBillingSubscriptionForm',
                billingPeriodId: null,
                subscriptionId: null,
            }
        },
        created() {
            this.billingPeriodId = this.$route.params.billingPeriodId;
            this.subscriptionId = this.$route.params.subscriptionId;
        }
    }
</script>
